<template>
  <div
    v-if="visible"
    class="act004-quiz-page-overlay"
    :class="{ 'act004-quiz-page-overlay--inline': inlineAnchored }"
    @click.self="handleBackdrop"
  >
    <div class="act004-quiz-page-overlay__stage">
      <div
        v-if="stemBox"
        class="act004-quiz-page-overlay__stem"
        :style="stemStyle"
      >
        {{ questionTitle }}
      </div>
      <div
        v-for="(opt, oi) in optionRows"
        :key="'opt-' + oi"
        class="act004-quiz-page-overlay__option"
        :style="optionStyle(oi)"
        @click="onToggleOption(oi)"
      >
        {{ opt.label }}
      </div>
      <div
        v-if="showNextButton"
        class="act004-quiz-page-overlay__next"
        :style="nextBtnStyle"
        @click="$emit('submit')"
      >
        {{ nextButtonLabel }}
      </div>
      <div
        v-else
        class="act004-quiz-page-overlay__submit-fixed"
        @click="$emit('submit')"
      >
        {{ submitting ? '提交中...' : '提交本题' }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  parseQuizLayoutConfig,
  quizHotspotBoxStyle,
  quizOptionSelectedStyle
} from '@/utils/activity-multi/quiz-page-layout'
import { mergeHotspotDebugStyle } from '@/utils/hotspot-debug'
import { rpxToPx } from '@/utils'

export default {
  name: 'Act004QuizPageOverlay',
  props: {
    visible: { type: Boolean, default: false },
    question: { type: Object, default: null },
    layoutConfig: { type: [Object, String], default: null },
    selectedOptionIds: { type: Array, default: () => [] },
    submitting: { type: Boolean, default: false },
    windowWidthPx: { type: Number, default: 375 },
    /** 嵌在活动页 background-wrapper 内，与打卡热点同一坐标系 */
    inlineAnchored: { type: Boolean, default: false }
  },
  computed: {
    parsedLayout() {
      return parseQuizLayoutConfig(this.layoutConfig)
    },
    stemBox() {
      return this.parsedLayout && this.parsedLayout.stem
    },
    stemStyle() {
      return mergeHotspotDebugStyle(quizHotspotBoxStyle(this.stemBox, this.rpxPx))
    },
    optionLayoutList() {
      return (this.parsedLayout && this.parsedLayout.options) || []
    },
    nextButtonBox() {
      return this.parsedLayout && this.parsedLayout.nextButton
    },
    showNextButton() {
      return !!this.nextButtonBox
    },
    nextButtonLabel() {
      const lb = this.nextButtonBox && this.nextButtonBox.label
      if (this.submitting) return '提交中...'
      return lb ? String(lb) : '提交本题'
    },
    nextBtnStyle() {
      return mergeHotspotDebugStyle(quizHotspotBoxStyle(this.nextButtonBox, this.rpxPx))
    },
    questionTitle() {
      const q = this.question
      return q && q.title ? String(q.title) : ''
    },
    optionRows() {
      const q = this.question
      const list = q && Array.isArray(q.options) ? q.options : []
      return list.map((row) => ({
        optionId: row && row.optionId != null ? row.optionId : null,
        label: row && row.label != null ? String(row.label) : ''
      }))
    },
    questionTypeUpper() {
      const t = this.question && this.question.questionType
      return String(t || 'SINGLE').toUpperCase()
    }
  },
  methods: {
    rpxPx(rpx) {
      return rpxToPx(rpx, this.windowWidthPx || 375)
    },
    optionStyle(oi) {
      const box = this.optionLayoutList[oi] || {}
      const item = this.optionRows[oi]
      const selected =
        item &&
        item.optionId != null &&
        this.selectedOptionIds.some((id) => String(id) === String(item.optionId))
      return mergeHotspotDebugStyle(quizOptionSelectedStyle(box, selected, this.rpxPx))
    },
    isSelected(oi) {
      const item = this.optionRows[oi]
      if (!item || item.optionId == null) return false
      return this.selectedOptionIds.some((id) => String(id) === String(item.optionId))
    },
    onToggleOption(oi) {
      const item = this.optionRows[oi]
      if (!item || item.optionId == null) return
      this.$emit('toggle-option', { optionId: item.optionId, questionType: this.questionTypeUpper })
    },
    handleBackdrop() {
      /* 页内答题不允许点遮罩关闭，避免误触 */
    }
  }
}
</script>

<style scoped>
.act004-quiz-page-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10050;
  pointer-events: none;
}
.act004-quiz-page-overlay--inline {
  position: absolute;
  z-index: 50;
}
.act004-quiz-page-overlay__stage {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.act004-quiz-page-overlay__stem,
.act004-quiz-page-overlay__option,
.act004-quiz-page-overlay__next {
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.act004-quiz-page-overlay__stem {
  cursor: default;
}
.act004-quiz-page-overlay--inline .act004-quiz-page-overlay__submit-fixed {
  position: absolute;
}
.act004-quiz-page-overlay__submit-fixed {
  position: fixed;
  left: 50%;
  bottom: 48px;
  transform: translateX(-50%);
  z-index: 10051;
  pointer-events: auto;
  padding: 12px 32px;
  background: #409eff;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}
</style>
